import { Box } from '@mui/material';
import { EmployeeLink, useEmployeeNamesService } from 'domain/shared/employee';
import { InputLoader } from 'framework/ui/mui-builder';
import { FieldProps, NameField, TextField, useFieldHelper } from 'framework/ui/field';
import { EMPTY_VALUE_INDICATOR, useAsyncValue } from 'framework/utils';
import { usePositionSlotValidationErrors } from '../PositionSlotValidationContext';
import PositionSlotValidationWarningIcon from './PositionSlotValidationWarningIcon';

const PositionSlotEmployeeField = ({ label, source = 'employeeAlias', ...props }: FieldProps) => {
  const { getEmployeeNameDataById } = useEmployeeNamesService();
  const { getValue: getEmployeeAlias } = useFieldHelper<string | null>({ source });
  const employeeAlias = getEmployeeAlias();
  const validationErrors = usePositionSlotValidationErrors(employeeAlias);

  const employeeName = useAsyncValue(
    () => (employeeAlias ? getEmployeeNameDataById(employeeAlias) : Promise.resolve({})),
    [employeeAlias],
  );

  if (!employeeAlias) {
    return <TextField value={EMPTY_VALUE_INDICATOR} label={label} {...props} />;
  }

  const employeeLink =
    employeeName === null ? (
      <EmployeeLink id={employeeAlias} name={employeeAlias} />
    ) : (
      <EmployeeLink
        id={employeeAlias}
        name={employeeName?.nameEn ? <NameField ignoredNameParts={[]} value={employeeName.nameEn} /> : employeeAlias}
      />
    );

  const wrappedEmployeeLink = (
    <Box flex={1} minWidth={0}>
      {employeeLink}
    </Box>
  );

  const value = (
    <Box display="flex" alignItems="center" gap={0.5} width="100%">
      <Box flex={1} minWidth={0} display="flex" alignItems="center">
        {employeeName === null ? <InputLoader /> : wrappedEmployeeLink}
      </Box>
      <Box width={20} minWidth={20} display="flex" justifyContent="center">
        {validationErrors.length > 0 ? <PositionSlotValidationWarningIcon errors={validationErrors} /> : null}
      </Box>
    </Box>
  );

  return <TextField value={value} label={label} {...props} />;
};

export default PositionSlotEmployeeField;
